// extracted by mini-css-extract-plugin
export default {"container":"UserLogin_container__wSpkU","logo":"UserLogin_logo__TRaSJ","formContainer":"UserLogin_formContainer__Ugx1i"};